import React from "react";

interface StatsPanelProps {
    label: string;
    value: string;
    icon?: string;
    handleShowLeaves?: () => void;
}

const StatsPanel: React.FC<StatsPanelProps> = ({ label, value, icon, handleShowLeaves }) => {
    return (
        <div onClick={handleShowLeaves} className=" p-8 rounded-lg flex flex-col items-center border-[1px] border-solid border-surface-border">
            <div className="text-2xl">{icon}</div>
            <div className="text-lg font-bold">{value}</div>
            <div className="text-gray-500">{label}</div>
        </div>
    );
};

export default StatsPanel;
